
@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="xs"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="xs"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="big"></ng-container>
}
}


<ng-template #xs>
    <div class="hotelwrapper_xs">
        <!--hotel-->
        <div class="hotelimgwrapper_xs">
            <ng-container *ngTemplateOutlet="hotelimgwrapperXs"></ng-container>
        </div>

        <!--hotelname-->
        <div class="hotelnamewrapper_xs">
            <ng-container *ngTemplateOutlet="hotelnamewrapper"></ng-container>
        </div>

        <!--price-->
        <div class="pricewrapper_xs">
            <ng-container *ngTemplateOutlet="pricewrapper"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #big>
    <div class="hotelwrapper">
        <!--hotel-->
        <div class="hotelimgwrapper">
            <ng-container *ngTemplateOutlet="hotelimgwrapper"></ng-container>
        </div>

        <!--hotelname-->
        <div class="hotelnamewrapper">
            <ng-container *ngTemplateOutlet="hotelnamewrapper"></ng-container>
        </div>

        <!--price-->
        <!-- <div class="pricewrapper">
            <ng-container *ngTemplateOutlet="pricewrapper"></ng-container>
        </div> -->

        <div class="sharwrapper">
            <app-share [shareLink]="shareLink()"
                [description]="hotel?.location?.name + (hotel?.location?.region?.name?.length > 0 ? ' (' +
                hotel?.location?.region?.name + ')': '') + '&#x0A;' + tmp_realparams?.reisedauerResult?.name + ' ' + tmp_realparams?.reisendeResult.adults + ' Personen' + ' ' + hotel?.offerList[0].boardType?.name +  ' ab ' + (hotel?.bestPricePerPerson?.value | number:'1.2-2') + ' € p.P.'"
                [title]="hotel?.name?.trim()" [imageurl]="imageList[0] | cacheResource">
            </app-share>
            <button (click)="addRemoveToFromFavorite($event)" class="m-favbtn">
                <mat-icon  class="m-fav" *ngIf="!inFavorites" matTooltip="Als Favorit markieren">
                    favorite_border
                </mat-icon>
                <mat-icon  class="m-fav" *ngIf="inFavorites" matTooltip="Von Favoriten entfernen">favorite
                </mat-icon>
            </button>
        </div>
    </div>
</ng-template>


<ng-template #pricewrapper>
    <div class="prcbzn">
        @if(higherPrice()) {
        <div class="flexdiv">
            <div class="prctext">
                <span>ab {{higherPrice() | number}} p.P.</span>
                <mat-icon  class="prci" (click)="fixinfo=true; $event.stopPropagation()"
                    (mouseover)="fixinfo=true"
                    (mouseleave)="(mediaService.media() === 'xs' || mediaService.media() === 'sm') ? fixinfo=true : fixinfo=false"
                    #triggerinfo="cdkOverlayOrigin" cdkOverlayOrigin fontIcon="info">
                </mat-icon>
            </div>
            @if(higherPricePr()) {
                <span class="purcw">
                    &minus; {{higherPricePr()}} %
                </span>
            }
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerinfo" [cdkConnectedOverlayOpen]="fixinfo"
            (overlayOutsideClick)="fixinfo=false">
            <div class="cc17infos mat-elevation-z1">
                <b>Ihr Angebotspreis ist {{ higherPrice() - curprice() }} € günstiger!</b><br><br>
                Ihr Reisepreis ist niedriger als der dritthöchste Preis, den Kunden für dasselbe Angebot
                bereits gesehen haben.
                Kurz gesagt: Ihr Reiseangebot ist besonders preiswert! <br><br>

                <b>Wichtige Informationen zum Reisepreis und möglichen Abweichungen:</b><br><br>
                Der angegebene Reisepreis unterliegt täglichen Schwankungen. Daher kann es bei der
                letzten Preisprüfung vor der
                Buchung zu kurzfristigen Preisänderungen durch den Veranstalter kommen.
            </div>
        </ng-template>
        }

        <div class="price_card_wrapper">
            <span class="prctw">ab <span class="prctotal">{{hotel?.bestPricePerPerson?.value | number}} €</span>
                p.P.</span>
            <span class="prcpp">(Gesamtpreis {{hotel?.totalPrice?.value | number}} €)</span>
        </div>
        <button class="sumagb" (click)="goToOffers()">Zum Angebot</button>
    </div>
</ng-template>


<ng-template #hotelnamewrapper>
    <div class="h-wrapper">
        <div class="namecontainer_col">
            <div class="topwrapper">
                <span class="hotelname">{{hotel?.name}}</span>
            </div>
        </div>
        <div class="locwrapperm">
            <div class="starts">
                <mat-icon  *ngFor="let cat of categoryAr;" class="stars">
                    {{cat === 1 ? 'star': 'star_half'}}
                </mat-icon>
            </div>
            @if(categoryAr?.length > 0) {
            <span class="seplocation">|</span>
            }
            <button class="namecontainer linkf" (click)="openMaps()">
                <!-- <mat-icon class="place_icon">place</mat-icon> -->
                <span class="ellipsis">{{hotel?.location?.name}} ({{hotel?.country?.name}})</span>
            </button>
        </div>
        <ng-container *ngIf="hotel?.rating?.recommendation || hotel?.rating?.count">
            <div class="bwertwrapper">
                <div class="hcheckbtnwrp">
                    <button class="reatingico" (click)="openReview($event)">
                        <mat-icon  class="reatingicomat-ico">
                            thumb_up_alt</mat-icon>
                        <span *ngIf="hotel?.rating?.recommendation"
                            class="reatingprc">{{hotel?.rating.recommendation}}%</span>
                    </button>
                    <img loading="lazy" src="assets/images/holidaycheck.svg" width="auto" height="30px" alt="holidaycheck">
                </div>
                <button class="bwertcount" (click)="openReview($event)">{{hotel?.rating?.count + (hotel?.rating?.count >
                    1 ? ' Bewertungen': '
                    Bewertung')}}</button>
            </div>
        </ng-container>
        <span class="previewtext">{{hotel?.catalogData?.previewText}}</span>
    </div>
    <div class="cc890">
        <div class="cc8901" [class.w100]="mediaService.media() === 'xs' || mediaService.media() === 'sm'">
            <div class="smalldesc">
                <span class="mb5">{{dauer}} <span class="colorgray">|</span> {{hotel?.offerList[0].boardType?.name}}</span>
                <span>{{prs}} <span class="colorgray">|</span> {{hotel?.offerList[0].roomType?.name}}</span>
            </div>
            <div>
                @if(hotel?.keywordList?.length > 0) {
                    <keywords [data]="hotel?.keywordList" class="keywordList"></keywords>
                }
            </div>
        </div>
        @if(mediaService.media() !== 'xs' && mediaService.media() !== 'sm') {
            <div class="pricewrapper">
                <ng-container *ngTemplateOutlet="pricewrapper"></ng-container>
            </div>
        }
    </div>
</ng-template>

<ng-template #hotelimgwrapper>
    @if(imageList()?.length > 0) {
        <imageslider [data]="imageList()" [radiustopleft]="true" [radiusbottomleft]="true"
            (clickOnImg)="openImageModal($event)" class="cardimg">
        </imageslider>
    }
</ng-template>

<ng-template #hotelimgwrapperXs>
    @if(imageList()?.length > 0) {
        <imageslider [data]="imageList()" [radiustopleft]="true" [radiustopright]="true"
            (clickOnImg)="openImageModal($event)" class="cardimg">
        </imageslider>
    }
    <div class="sharwrapper">
        <app-share [shareLink]="shareLink()"
            [description]="hotel?.location?.name + (hotel?.location?.region?.name?.length > 0 ? ' (' +
            hotel?.location?.region?.name + ')': '') + '&#x0A;' + tmp_realparams?.reisedauerResult?.name + ' ' + tmp_realparams?.reisendeResult.adults + ' Personen' + ' ' + hotel?.offerList[0].boardType?.name +  ' ab ' + (hotel?.bestPricePerPerson?.value | number:'1.2-2') + ' € p.P.'"
            [title]="hotel?.name?.trim()" [imageurl]="imageList[0] | cacheResource">
        </app-share>
        <button (click)="addRemoveToFromFavorite($event)" class="m-favbtn">
            <mat-icon  class="m-fav" *ngIf="!inFavorites" matTooltip="Als Favorit markieren">
                favorite_border
            </mat-icon>
            <mat-icon  class="m-fav" *ngIf="inFavorites" matTooltip="Von Favoriten entfernen">favorite
            </mat-icon>
        </button>
    </div>
</ng-template>